/**
 * AskArloCard.js - Poster card for a resolved chat pick.
 *
 * Artwork/title are always local catalog data. The card renders 2:3
 * portrait, so the portrait `poster` field wins over the landscape
 * `spotlight_poster`, and the raw value is rewritten to a CDN-sized URL —
 * both conventions mirror ChannelCard's poster format. The reason line is
 * Arlo's, rendered only when present. Navigation + telemetry live in the
 * panel's onClick — the card only reports which pick was tapped.
 */
import React from 'react';

const posterUrl = channel => {
  const raw =
    channel.poster ||
    channel.spotlight_poster ||
    (channel.image && (channel.image.poster || channel.image.spotlight_poster)) ||
    null;
  if (!raw) {return null;}

  const imageId = raw.startsWith('http') ? new URL(raw).pathname.split('/').pop() : raw;
  return `https://sportstvdspmedia.cachefly.net/images/${imageId}/320/480?webp=1`;
};

const AskArloCard = ({ pick, onClick }) => {
  const { channel, reason } = pick;
  const poster = posterUrl(channel);
  const title = channel.title || channel.slug;

  return (
    <button
      type="button"
      onClick={() => onClick(pick)}
      data-testid={`ask-arlo-card-${channel.slug}`}
      className="p-0 text-left transition-transform bg-transparent border-0 group active:scale-[0.97]"
    >
      {poster ? (
        <img
          src={poster}
          alt={title}
          className="w-full aspect-[2/3] object-cover rounded-lg border border-white/10 group-hover:border-[#FCC834]/50"
        />
      ) : (
        <div className="flex items-center justify-center w-full px-2 text-sm text-center aspect-[2/3] rounded-lg bg-white/5 border border-white/10 text-white/60">
          {title}
        </div>
      )}
      <p className="mt-2 text-sm font-medium truncate text-white/90">{title}</p>
      {reason && <p className="mt-0.5 text-xs text-white/50">{reason}</p>}
    </button>
  );
};

export default AskArloCard;
